import {fragment, placeholder, vbox} from '@xh/hoist/cmp/layout';
import {creates, hoistCmp, HoistProps} from '@xh/hoist/core';
import {button} from '@xh/hoist/desktop/cmp/button';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {Icon} from '@xh/hoist/icon';
import {configurableChart} from '../../../cmp/chartSpec/ConfigurableChart';
import {configurableGrid} from '../../../cmp/gridSpec/ConfigurableGrid';
import {ResearchWidgetKind} from '../../../data/ResearchTypes';
import {researchDataDialog} from './ResearchDataDialog';
import {ResearchWidgetModel} from './ResearchWidgetModel';

interface ResearchWidgetProps extends HoistProps<ResearchWidgetModel> {
    kind: ResearchWidgetKind;
}

/** A grid or chart over a research dataset - see ResearchWidgetModel. */
export const researchWidget = hoistCmp.factory<ResearchWidgetProps>({
    model: creates(ResearchWidgetModel),
    render({model}) {
        return fragment(panel({item: body(), mask: 'onLoad'}), researchDataDialog({model: model.dataDialogModel}));
    }
});

const body = hoistCmp.factory<ResearchWidgetModel>({
    render({model}) {
        const {source, problem, gridModel, chartModel, tabModel} = model;

        if (!source) {
            return placeholder(
                vbox({
                    alignItems: 'center',
                    items: [
                        model.kind === 'grid' ? Icon.grid({size: '2x'}) : Icon.chartLine({size: '2x'}),
                        button({text: 'Choose data', icon: Icon.database(), outlined: true, marginTop: 10, onClick: () => model.openDataDialog()})
                    ]
                })
            );
        }

        if (problem) return placeholder(Icon.warning(), problem);
        if (tabModel.tickerProblem) return placeholder(tabModel.tickerProblem);
        if (!tabModel.ticker) return placeholder('Select security');

        return gridModel ? configurableGrid({model: gridModel}) : configurableChart({model: chartModel});
    }
});
